import { render, staticRenderFns } from "./apikey.vue?vue&type=template&id=13bb79e8&"
import script from "./apikey.vue?vue&type=script&lang=js&"
export * from "./apikey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports